import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  class="explain-reviewable"
  @closeModal={{@closeModal}}
  @title={{i18n "review.explain.title"}}
>
  <:body>
    <ConditionalLoadingSpinner @condition={{this.loading}}>
      <table>
        <tbody>
          <tr>
            <th>{{i18n "review.explain.formula"}}</th>
            <th>{{i18n "review.explain.subtotal"}}</th>
          </tr>
          {{#each this.reviewableExplanation.scores as |s|}}
            <tr>
              <td>
                <ScoreValue @value="1.0" />
                <ScoreValue @value={{s.type_bonus}} @label="type_bonus" />
                <ScoreValue
                  @value={{s.take_action_bonus}}
                  @label="take_action_bonus"
                />
                <ScoreValue
                  @value={{s.trust_level_bonus}}
                  @label="trust_level_bonus"
                />
                <ScoreValue
                  @value={{s.user_accuracy_bonus}}
                  @label="user_accuracy_bonus"
                />
              </td>
              <td class="sum">{{float s.score}}</td>
            </tr>
          {{/each}}
          <tr class="total">
            <td>{{i18n "review.explain.total"}}</td>
            <td class="sum">
              {{float this.reviewableExplanation.total_score}}
            </td>
          </tr>
        </tbody>
      </table>

      <table class="thresholds">
        <tbody>
          <tr>
            <td>{{i18n "review.explain.min_score_visibility"}}</td>
            <td class="sum">
              {{float this.reviewableExplanation.min_score_visibility}}
            </td>
          </tr>
          <tr>
            <td>{{i18n "review.explain.score_to_hide"}}</td>
            <td class="sum">
              {{float this.reviewableExplanation.hide_post_score}}
            </td>
          </tr>
        </tbody>
      </table>
    </ConditionalLoadingSpinner>
  </:body>
  <:footer>
    <DButton @action={{@closeModal}} @label="close" />
  </:footer>
</DModal>
*/
{
  "id": "vRe1dHyq",
  "block": "[[[8,[39,0],[[24,0,\"explain-reviewable\"]],[[\"@closeModal\",\"@title\"],[[30,1],[28,[37,1],[\"review.explain.title\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[8,[39,2],null,[[\"@condition\"],[[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[10,\"table\"],[12],[1,\"\\n        \"],[10,\"tbody\"],[12],[1,\"\\n          \"],[10,\"tr\"],[12],[1,\"\\n            \"],[10,\"th\"],[12],[1,[28,[35,1],[\"review.explain.formula\"],null]],[13],[1,\"\\n            \"],[10,\"th\"],[12],[1,[28,[35,1],[\"review.explain.subtotal\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"reviewableExplanation\",\"scores\"]]],null]],null],null,[[[1,\"            \"],[10,\"tr\"],[12],[1,\"\\n              \"],[10,\"td\"],[12],[1,\"\\n                \"],[8,[39,5],null,[[\"@value\"],[\"1.0\"]],null],[1,\"\\n                \"],[8,[39,5],null,[[\"@value\",\"@label\"],[[30,2,[\"type_bonus\"]],\"type_bonus\"]],null],[1,\"\\n                \"],[8,[39,5],null,[[\"@value\",\"@label\"],[[30,2,[\"take_action_bonus\"]],\"take_action_bonus\"]],null],[1,\"\\n                \"],[8,[39,5],null,[[\"@value\",\"@label\"],[[30,2,[\"trust_level_bonus\"]],\"trust_level_bonus\"]],null],[1,\"\\n                \"],[8,[39,5],null,[[\"@value\",\"@label\"],[[30,2,[\"user_accuracy_bonus\"]],\"user_accuracy_bonus\"]],null],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"td\"],[14,0,\"sum\"],[12],[1,[28,[35,6],[[30,2,[\"score\"]]],null]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[2]],null],[1,\"          \"],[10,\"tr\"],[14,0,\"total\"],[12],[1,\"\\n            \"],[10,\"td\"],[12],[1,[28,[35,1],[\"review.explain.total\"],null]],[13],[1,\"\\n            \"],[10,\"td\"],[14,0,\"sum\"],[12],[1,\"\\n              \"],[1,[28,[35,6],[[30,0,[\"reviewableExplanation\",\"total_score\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,\"table\"],[14,0,\"thresholds\"],[12],[1,\"\\n        \"],[10,\"tbody\"],[12],[1,\"\\n          \"],[10,\"tr\"],[12],[1,\"\\n            \"],[10,\"td\"],[12],[1,[28,[35,1],[\"review.explain.min_score_visibility\"],null]],[13],[1,\"\\n            \"],[10,\"td\"],[14,0,\"sum\"],[12],[1,\"\\n              \"],[1,[28,[35,6],[[30,0,[\"reviewableExplanation\",\"min_score_visibility\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"tr\"],[12],[1,\"\\n            \"],[10,\"td\"],[12],[1,[28,[35,1],[\"review.explain.score_to_hide\"],null]],[13],[1,\"\\n            \"],[10,\"td\"],[14,0,\"sum\"],[12],[1,\"\\n              \"],[1,[28,[35,6],[[30,0,[\"reviewableExplanation\",\"hide_post_score\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,7],null,[[\"@action\",\"@label\"],[[30,1],\"close\"]],null],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\",\"s\"],false,[\"d-modal\",\"i18n\",\"conditional-loading-spinner\",\"each\",\"-track-array\",\"score-value\",\"float\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/explain-reviewable.hbs",
  "isStrictMode": false
});